export const environment = {
  production: true,
  apiUrl: "https://api.welcome.engagetech.net",
  mixPanelToken: "f7fd25e41087d85bae8854e914f78e64",
  sentryDsn: "https://6d1f8226d37b4fcaa9cc70ea812e9a6c@sentry.engagelabs.io/8",
  signInUrl: "https://engage.app.engagetech.net"
};
